
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 114.204 114.204"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_1-2"}},[_c('path',{attrs:{"d":"M57.102 114.204C25.616 114.204 0 88.588 0 57.102S25.616 0 57.102 0s57.102 25.616 57.102 57.102-25.616 57.102-57.102 57.102zM57.102 8C30.027 8 8 30.027 8 57.102s22.027 49.102 49.102 49.102 49.102-22.027 49.102-49.102S84.177 8 57.102 8z"}}),_c('path',{attrs:{"d":"M57.077 57.102h40.696c0 22.325-18.371 40.696-40.696 40.696S16.381 79.427 16.381 57.102s18.371-40.696 40.696-40.696v40.696z"}})])])
          )
        }
      }
    